module.exports = "./img/b6d571ff98ab84eb32561c0c4b157c2c.jpg";